function initFocusIndicators() {
  const links = document.querySelectorAll('a.collection-links__image');
  console.log('initFocusIndicators found:', links.length, 'links');
  
  links.forEach((link) => {
    link.addEventListener('focus', () => {
      link.style.setProperty('border', '2px solid #de0090', 'important');
    });

    link.addEventListener('blur', () => {
      link.style.removeProperty('border');
    });
  });
}

// Try immediately
initFocusIndicators();

// Also try after a short delay in case slideshow renders late
setTimeout(initFocusIndicators, 500);
setTimeout(initFocusIndicators, 1500);